import { createReducer, on } from '@ngrx/store';

import { initialState, State } from './admin-users.state';
import * as AdminUsersActions from './admin-users.actions';

export const adminUsersReducer = createReducer<State>(
  initialState,
  on(
    AdminUsersActions.loadUsers,
    (state): State => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    AdminUsersActions.loadUsersSuccess,
    (state, { users }): State => ({
      ...state,
      users,
      loading: false,
      error: null,
    }),
  ),
  on(
    AdminUsersActions.loadUsersFailure,
    (state, { error }): State => ({
      ...state,
      loading: false,
      error,
    }),
  ),
  on(
    AdminUsersActions.updateRolesSuccess,
    (state, { userId, roles }): State => ({
      ...state,
      users: state.users.map(user =>
        user._id === userId ? { ...user, roles } : user,
      ),
    }),
  ),

  // API Key reducers (SEOMS-349)
  on(
    AdminUsersActions.loadApiKeys,
    (state): State => ({
      ...state,
      apiKeysLoading: true,
      apiKeysError: null,
    }),
  ),
  on(
    AdminUsersActions.loadApiKeysSuccess,
    (state, { apiKeys }): State => ({
      ...state,
      apiKeys,
      apiKeysLoading: false,
      apiKeysError: null,
    }),
  ),
  on(
    AdminUsersActions.loadApiKeysFailure,
    (state, { error }): State => ({
      ...state,
      apiKeysLoading: false,
      apiKeysError: error,
    }),
  ),
  on(
    AdminUsersActions.createApiKeySuccess,
    (state, { response }): State => ({
      ...state,
      createdApiKey: response,
    }),
  ),
  on(
    AdminUsersActions.revokeApiKeySuccess,
    (state, { keyId }): State => ({
      ...state,
      apiKeys: state.apiKeys.map(key =>
        key._id === keyId
          ? { ...key, isActive: false, revoked: new Date().toISOString() }
          : key,
      ),
    }),
  ),
  on(
    AdminUsersActions.clearCreatedApiKey,
    (state): State => ({
      ...state,
      createdApiKey: null,
    }),
  ),

  // User token reducers (SEOMS-349 inline expand)
  on(
    AdminUsersActions.loadUserTokens,
    (state, { userId }): State => ({
      ...state,
      expandedUserId: userId,
      userTokens: [],
      userTokensLoading: true,
      userTokensError: null,
    }),
  ),
  on(
    AdminUsersActions.loadUserTokensSuccess,
    (state, { tokens }): State => ({
      ...state,
      userTokens: tokens,
      userTokensLoading: false,
    }),
  ),
  on(
    AdminUsersActions.loadUserTokensFailure,
    (state, { error }): State => ({
      ...state,
      userTokensLoading: false,
      userTokensError: error,
    }),
  ),
  on(
    AdminUsersActions.collapseUserTokens,
    (state): State => ({
      ...state,
      expandedUserId: null,
      userTokens: [],
      userTokensError: null,
    }),
  ),
  on(
    AdminUsersActions.revokeUserTokensSuccess,
    (state): State => ({
      ...state,
      expandedUserId: null,
      userTokens: [],
      userTokensError: null,
    }),
  ),
);
